import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets.app/images/card-details-visa.svg'
import _imports_1 from '@/assets.app/images/card-details.svg'


const _hoisted_1 = { class: "payment" }
const _hoisted_2 = { class: "payment__title-box" }
const _hoisted_3 = {
  key: 0,
  class: "payment-card"
}
const _hoisted_4 = { class: "payment-card-num" }
const _hoisted_5 = { class: "payment-card__unit" }
const _hoisted_6 = { class: "payment-card__date" }
const _hoisted_7 = { class: "payment-card__text" }
const _hoisted_8 = { class: "payment-card__brand payment-card__text--black-text" }
const _hoisted_9 = { class: "payment-card__expiration payment-card__text--black-text" }
const _hoisted_10 = { class: "payment-card__icon" }
const _hoisted_11 = {
  key: 0,
  class: "card-details__icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  class: "card-details__icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_13 = {
  key: 1,
  class: "payment-card payment-card--no-card"
}
const _hoisted_14 = { class: "payment-card__no-card" }

import { ref } from 'vue'

import { BillingView } from '@/models/billing'

import CardEditPopup from './CardEditPopup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingDataPaid.PaymentInfo',
  props: {
    billing: {}
  },
  setup(__props: any) {

const props = __props

const popupCardEdit = ref<InstanceType<typeof CardEditPopup> | null>(null)

function payment_type_text(): string {
  switch (props.billing.stripe_payment_type) {
    case 'link':
      return 'Stripe Link'
    case 'cashapp':
      return 'Cash App Pay'
    case 'amazon_pay':
      return 'Amazon Pay'
  }
  return 'an alternative payment method'
}

function editCard(): void {
  if (!popupCardEdit.value) {
    return
  }

  popupCardEdit.value.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "payment__title" }, "Payment Information", -1)),
      _createElementVNode("a", {
        class: "payment__edit payment-edit-btn",
        onClick: editCard
      }, "Edit"),
      _createVNode(CardEditPopup, {
        ref_key: "popupCardEdit",
        ref: popupCardEdit,
        billing: __props.billing
      }, null, 8, ["billing"])
    ]),
    (__props.billing.card_data?.last4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _cache[1] || (_cache[1] = _createStaticVNode("<span class=\"payment-card__unit\"><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i></span><span class=\"payment-card__unit\"><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i></span><span class=\"payment-card__unit\"><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i></span>", 3)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.billing.card_data.last4), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(__props.billing.card_data.brand), 1),
              _cache[2] || (_cache[2] = _createTextVNode(" - Expires ", -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString(__props.billing.card_data.exp_month) + "/" + _toDisplayString(__props.billing.card_data.exp_year), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (__props.billing.card_data?.brand === 'Visa')
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : (_openBlock(), _createElementBlock("img", _hoisted_12))
            ])
          ])
        ]))
      : (__props.billing.stripe_payment_type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _cache[3] || (_cache[3] = _createTextVNode(" You paid with ", -1)),
              _createElementVNode("strong", null, _toDisplayString(payment_type_text()), 1),
              _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})